import React from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { UsageChart } from '@vfgroup-oneplatform/foundation/Components';

import overViewPropTypes from '../../../../Common/PropTypes/overViewPropTypes';
import {
  getFormattedDate as formatDate,
  getUsagePlaceholderBasedOnUsageType,
  getUsageProperColor,
} from '../../../Utils/Getter';
import UsageCard from '../UsageCard';

import styles from './ChartUsageCard.Styles';
import { getChartColumnStyles, getChartData, getChartContainerStyle } from './ChartUsageCard.Utils';

function ChartUsageCard({
  title,
  overview,
  usage,
  containerStyle,
  images,
  renderFooter,
  ...props
}) {
  const { period, type, usage: overviewUsage, startDate, endDate } = overview;

  return (
    <>
      <UsageCard
        title={title}
        date={formatDate({
          period: period,
          startDate: startDate,
          endDate: endDate,
        })}
        renderFooter={renderFooter}
        subtitle={getUsagePlaceholderBasedOnUsageType(
          type,
          overviewUsage?.value,
          overviewUsage?.valueType,
        )}
        images={images}
        containerStyle={[styles.itemContainerStyle, containerStyle]}
      >
        <UsageChart
          data={getChartData(usage)}
          colors={[getUsageProperColor(type)]}
          style={{
            ...getChartColumnStyles(period),
            chartContainerStyle: getChartContainerStyle(period),
          }}
        />
      </UsageCard>
    </>
  );
}

ChartUsageCard.propTypes = {
  overview: PropTypes.shape({
    period: PropTypes.string,
    type: PropTypes.string,
    usage: PropTypes.shape({
      valueType: PropTypes.string,
      value: PropTypes.number,
    }),
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  usage: overViewPropTypes.usage,
  containerStyle: ViewPropTypes.style,
  images: PropTypes.object,
  userName: PropTypes.string,
  renderFooter: PropTypes.func,
  title: PropTypes.string,
};

export default ChartUsageCard;
